<template>
    <textfield-screen
            id="firstName"
            :title="$ml.get('setMiddleNameReg')"
            v-model="text"
            :is-not-valid="isNotValid"
            :is-not-valid-message="isNotValidMessage"
            :maxlength="30"
            :headerImg="3"
            :disabledNextButton="disabled"
            @next="nextScreen"
            @back="back"
    ></textfield-screen>
</template>

<script>
    import Vue from 'vue'
    import TextfieldScreen from "../../../components/layout/textfield-screen";
    import {default as Profile, filteredName, isWrongFullName} from "../../../helpers/profile";

    export default {
        name: "setMiddleName",
        components: {TextfieldScreen},
        data() {
            return {
                isNotValid: false,
                isNotValidMessage: this.$ml.get('setFullNameErrorMessage'),
                text: Profile.middleName,
            }
        },
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'accessRecovery')
                    this.$router.push({ name: 'AccessRecoveryFio'});
                else
                    this.$router.replace({ name: 'RegistrationFio'});
            }
        },
        watch: {
            text: function (val) {
                Vue.nextTick(() => {
                    this.text = filteredName(val);
                });
            },
        },
        computed: {
            disabled: function () {
                return this.text.trim().length === 0
            }
        },
        methods: {
            nextScreen: function () {
                if (!this.text.trim())
                    return;
                if (isWrongFullName((Profile.lastName.trim() + ' ' + Profile.firstName.trim() + ' ' + this.text.trim()).trim())) {
                    this.isNotValid = true;
                    setTimeout(()=>{
                        this.isNotValid = false;
                    }, 2500);
                    return;
                }

                Profile.setData({middleName: this.text});
                if (Profile.process === 'accessRecovery')
                    this.$router.push({ name: 'AccessRecoveryStartBirthday'});
                else
                    this.$router.push({ name: 'RegistrationStartBirthday'});
            },
            back: function () {
                this.$router.back();
            }
        },
    }
</script>

<style scoped>

</style>